
import useMasterGroups from "@/hooks/data/useMasterGroups";
import { createContext } from "react"

export interface IMasterGroupsContext extends ReturnType<typeof useMasterGroups> {
}

export const MasterGroupsContext = createContext<IMasterGroupsContext>({
    data: undefined,
    idMap: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default MasterGroupsContext;